import { render } from "./ProgressionBar.vue?vue&type=template&id=08c80530&scoped=true"
import script from "./ProgressionBar.vue?vue&type=script&lang=js"
export * from "./ProgressionBar.vue?vue&type=script&lang=js"

import "./ProgressionBar.vue?vue&type=style&index=0&id=08c80530&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c80530"]])

export default __exports__